import capitalizeFirst from './capitalizeFirst';
import slashDate from './slashDate';
import employeeFilter from './employee.filter';
import lpadAuto from './lpadAuto';
import lpad from './lpad';

let filtersModule = angular

  .module('common.filters', [])

  .filter('capitalizeFirst', capitalizeFirst)
  .filter('slashDate', slashDate)
  .filter('employeeFilter', employeeFilter)
  .filter('lpadAuto', lpadAuto)
  .filter('lpad', lpad)

  .name;

export default filtersModule;



// WEBPACK FOOTER //
// ./client/app/common/filters/filters.js